import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 引入element ui 库
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
//引入公用样式
import '../src/assets/css/index.css'
// 引入Echarts
import Echarts from "echarts";

Vue.prototype.$echarts = Echarts;
Vue.use(ElementUI);
Vue.config.productionTip = false;
// 富文本插件
import VueQuillEditor from 'vue-quill-editor'
//引入插件样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import axios from './utils/axios'

import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard);

Vue.prototype.$axios = axios;
//正式服
Vue.prototype.fixedIp = 'https://apius.wykcshi.com';

//测试服
//Vue.prototype.fixedIp = 'https://apixs.wykcshi.com';

import Ajax from 'axios';
import qs from 'qs'

Vue.prototype.$ajax = Ajax;
Vue.prototype.$qs = qs;

Vue.prototype.envName = '';
if (location.host === 'hw.wykcshi.com') {
    Ajax.defaults.baseURL = 'https://apius.wykcshi.com/'; // 正式
    Vue.prototype.envName = '海外';
} else if (location.host === 'haiwai.wykcshi.com') {
    Ajax.defaults.baseURL = 'https://apixs.wykcshi.com/'; // 测试
} else if (location.host === 'cy.wykcshi.com') {
    Ajax.defaults.baseURL = 'https://cyapi.wykcshi.com/'; // 传音
    Vue.prototype.envName = '传音';
} else {
    Ajax.defaults.baseURL = 'http://hwapi.wykcshi.loc'; // 本地
}

import MetaInfo from 'vue-meta-info'

Vue.use(MetaInfo);

Vue.use(VueQuillEditor);

import JsonExcel from 'vue-json-excel'

Vue.component('downloadExcel', JsonExcel);
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');

Vue.filter('FormatDigit', (arg1) => {
    if (arg1) {
        return (arg1 * 100).toFixed(2)
    } else {
        return 0
    }
})